import { render, staticRenderFns } from "./SystemLinks.vue?vue&type=template&id=dd09e8ea&lang=pug&"
import script from "./SystemLinks.vue?vue&type=script&lang=ts&"
export * from "./SystemLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports